// ** Initial State
const initialState = {
  NotificationList: [],
  loading_Notification: false,
  error_Notification: '',

  ReportList:[],
  loading_Report:false,
  error_Report: '',

  RegionList:[],
  loading_Region:false,
  error_Region: '',

  UserList:[],
  loading_User:false,
  error_User: '',

  CssUserList:[],
  loading_CssUser:false,
  error_CssUser: ''

}
const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    // CSS Notification
       case 'Notification_LOADING': {
           return {
               ...state,
               loading_Notification: true,
               error_Notification:''
           }
       }
       case 'Notification_SUCCESS': {
           return {
               ...state,
               NotificationList: action.data,
               loading_Notification: false
           }
       }
       case 'Notification_ERROR': {
           return {
               ...state,
               loading_Notification: false,
               error_Notification: action.error
           }
       }


    // All Report
       case 'Report_LOADING': {
           return {
               ...state,
               loading_Report: true,
               error_Report:''
           }
       }
       case 'Report_SUCCESS': {
           return {
               ...state,
               ReportList: action.data,
               loading_Report: false
           }
       }
       case 'Report_ERROR': {
           return {
               ...state,
               loading_Report: false,
               error_Report: action.error
           }
       }


    // All Region
       case 'Region_LOADING': {
           return {
               ...state,
               loading_Region: true,
               error_Region:''
           }
       }
       case 'Region_SUCCESS': {
           return {
               ...state,
               RegionList: action.data,
               loading_Region: false
           }
       }
       case 'Region_ERROR': {
           return {
               ...state,
               RegionList: [],
               loading_Region: false,
               error_Region: action.error
           }
       }

       // All User
       case 'User_LOADING': {
           return {
               ...state,
               loading_User: true,
               error_User:''
           }
       }
       case 'User_SUCCESS': {
           return {
               ...state,
               UserList: action.data,
               loading_User: false
           }
       }
       case 'User_ERROR': {
           return {
               ...state,
               UserList: [],
               loading_User: false,
               error_User: action.error
           }
       }

        // All CSS User
       case 'CssUser_LOADING': {
           return {
               ...state,
               loading_CssUser: true,
               error_CssUser:''
           }
       }
       case 'CssUser_SUCCESS': {
           return {
               ...state,
               CssUserList: action.data,
               loading_CssUser: false
           }
       }
       case 'CssUser_ERROR': {
           return {
               ...state,
               CssUserList: [],
               loading_CssUser: false,
               error_CssUser: action.error
           }
       }

         // CSS User Delete
       case 'deleteUser_LOADING': {
           return {
               ...state,
               loading_deleteUser: true,
               error_deleteUser:''
           }
       }
       case 'deleteUser_SUCCESS': {
           return {
               ...state,
               deleteUser: action.data,
               loading_CssUser: false
           }
       }
       case 'deleteUser_ERROR': {
           return {
               ...state,
               deleteUser: [],
               loading_deleteUser: false,
               error_deleteUser: action.error
           }
       }

    default:
      return state
  }
}

export default commonReducer
